import ContactAndOpeningTimes from '../../contactInfo/ContactAndOpeningTimes';

export default function CallUs() {

    return (
        <span className="sidebar-component">
            <ContactAndOpeningTimes stylingRegion={`sidebar`}/>
        </span>
    )
}